import { passwordStrength } from '@/lib/password-strength';
import { cn } from '@/lib/cn';

export function PasswordStrength({ password }: { password: string }) {
  const { percent, rules } = passwordStrength(password);

  const barColor =
    percent < 40 ? 'bg-red-500' : percent < 80 ? 'bg-amber-500' : 'bg-emerald-500';

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs text-manejai-bark/60">
        <span>Força da senha</span>
        <span className="font-medium text-manejai-bark">{percent}%</span>
      </div>
      <div className="h-2 rounded-full bg-manejai-sand overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-all duration-300', barColor)}
          style={{ width: `${percent}%` }}
        />
      </div>
      <ul className="grid gap-1 text-xs">
        {rules.map((r) => (
          <li
            key={r.id}
            className={cn(
              'flex items-center gap-2',
              r.ok ? 'text-emerald-700' : 'text-manejai-bark/50',
            )}
          >
            <span className="w-3 text-center">{r.ok ? '✓' : '○'}</span>
            {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
